exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 959px) {\n  .progressbar span.number {\n    display: block;\n  }\n  .progressbar p.bodytext {\n    line-height: 1;\n    text-align: center;\n  }\n}\n@media screen and (max-width: 599px) {\n  .progressbar p.bodytext {\n    text-align: center;\n  }\n}\n", ""]);

// exports
